<template>
    <!-- 数据列表  -->
    <div class="dataList">
        <div v-for="(item,i) in dataList.list" :key="i" class="flex align-center text-33 justify-start">
            <img class="pic" v-if="dataList.isContact" :src="item.head_img||$nodata" >
            <img class="pic" v-if="dataList.isSkill" :src="item.logo||$nodata" >
            <div class="listInfo flex-one flex justify-between align-center">
                <div class="btnFl">
                    <div class="text-33">
                        <b class="text-24">{{dataList.isContact?item.user_name:dataList.isSkill?item.enterprise_title:''}}</b>{{dataList.isContact?item.position_name:dataList.isSkill?item.position_name:''}}
                    </div>
                    <span class="text-16">{{dataList.isContact?item.user_phone:dataList.isSkill?item.address:''}}</span>
                </div>
                <div class="btnRi  text-99">
                    <el-input-number v-model="item.sort"  :min="0" @change="handleChange(item)"></el-input-number>
                    <!-- <sort :sort="item.sort" @handleChangeFun="chidhandleChangeFun"></sort> -->
                    <!-- <input type="number" v-model="item.sort" name="points" min="1" max="10" placeholder="排序"/> -->
                    <div class="flex justify-start editDel">
                        <p class="edit poi" @click="childEdit(dataList.isContact?item.user_id:dataList.isSkill?item.id:'')">编辑</p>
                        <p class="del poi" @click="childDelBtn(dataList.isContact?item.user_id:dataList.isSkill?item.id:'')">移除</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    
    data() {
        return {
            
        };
    },
    props:['dataList'],
    methods: {
        childEdit(id){
            this.$emit('chidEditFun', id);
        },
        childDelBtn(id){
            this.$emit('chidDelFun', id);
        },
        handleChange(value){
            console.log(value)
            this.$emit('handleChangeFun', value);
        }
    },
};
</script>
<style>

.el-input-number .el-input__inner{
    padding:0  50px  0 0;
}
.el-input-number{
    margin-bottom:20px;
}

.el-input-number [class*=" el-icon-"], .el-input-number [class^=el-icon-]{
    width:15px;
    height:8px;
    margin-bottom: 10px;
}
.el-icon-minus:before{
    display:block;
    content:'';
    width:15px;
    height:8px;
    background:url('../../../public/img/jian.png') no-repeat;
    background-size: 15px 8px;
}
.el-icon-plus:before{
    display:block;
    width:15px;
    height:8px;
    content:'';
    background:url('../../../public/img/jia.png') no-repeat;
    background-size: 15px 8px;
}
.el-input-number__decrease, .el-input-number__increase{
    height:21px;
    background:transparent;
    
}
.el-input-number__decrease{
    left:auto;
    right:1px;
    bottom: auto;
    border-right: 0;
    top: 20px;
    border-left: 1px solid #DCDFE6;
    border-right:0;
}
</style>
<style scoped>
.btnRi input[type='number']{
    margin:0 0 20px 10px;
}
input[type='number']{
    display:block;
    width:145px;
    border: 1px solid #cccccc;
    text-align:center
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
    background:red
}
.apply {
  height: 30px;
  line-height: 30px;
  width: 41px;
  background: #ff7b00;
}
.dataList .pic{
    width:98px;
    height:98px;
    border-radius:5px;
    margin-right:25px;
    object-fit: contain;
}
.dataList>div {
    padding:28px 0;
    border-bottom:1px solid #eee;
}
.listTitle{
    font-size:24px;
}
.listDesc{
    font-size:16px;
    line-height:22px;
    margin:25px 0 20px;
}
.listInfo p{
    font-size:16px;
    padding-left:28px;
    line-height:18px;
    background-size: 17px 100%;
    background-position:center center;
}
.btnFl div{
    font-size:18px;
    margin-bottom:15px;
}
.btnFl div b{
    padding-right:13px;
}
.btnFl span{
    font-size:16px;
}
.listInfo p.edit{
    margin-right:35px;
}
.listInfo p.collect{
    background: url("../../../public/img/collect.png") no-repeat;
}
.listInfo p.zan{
    background: url("../../../public/img/zan.png") no-repeat;
}
.listInfo p.xiaoxi{
    background: url("../../../public/img/xiaoxi.png") no-repeat;
}
.listInfo p.del{
    background: url("../../../public/img/del.png") no-repeat;
}
.listInfo p.edit{
    background: url("../../../public/img/edit.png") no-repeat;
}
.listBtn  i{
    display:block;
    width:1px;
    height:18px;
    background:#999;
    margin:0 20px;
}
.editDel{
    padding: 0 12px;
}
</style>